import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Toaster } from '@nokowazzi/ui';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}
